/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./copyWizard.vue?vue&type=template&id=a145a882"
import script from "./copyWizard.vue?vue&type=script&lang=js"
export * from "./copyWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports